export default function BillingPage() {
    return (
        <div className="placeholder-page" style={{ padding: '2rem', maxWidth: 720, margin: '0 auto' }}>
            <h1>Billing</h1>
            <p>Subscription management is coming soon.</p>
        </div>
    );
}
